import axios from "axios"
import { del, get, post, put, getPDF } from "./api_helper"
import * as url from "./url_helper"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
const postJwtRegister = (_url, data) => {
  return axios
    .post(_url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          case 400:
            message = err.response
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}


export const postJwtRegister1 = data => post(url.POST_JWT_SIGNUP, data)
//const postJwtRegister = data => post(url.POST_REGISTER_USER, data)

// Login Method
const postJwtLogin = data => post(url.POST_JWT_LOGIN, data)

const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

// get messages
export const getMessages = (roomId = "") =>
  get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } })

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message)

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS)

// users
export const getUsers = (params) => get(url.GET_USERS, params)
export const addUser = data => post(url.ADD_USER, data)
export const editUser = data => put(`${url.EDIT_USER}/${data.id}`, data)
export const deleteUser = id => del(`${url.DELETE_USER}/${id}`)
export const resetPwd = id => del(`${url.RESET_PWD}/${id}/resetpassword`)
export const changePasswordByAdmin = (id, data) => put(`${url.CHANGE_PWD}/${id}/password`, data)

// audit
export const getAudits = () => get(url.GET_AUDITS)

// group audit testing
export const getGroupAudits = () => get(url.GET_GROUP_AUDITS)

export const postBirthDetails = birthDetail => post(url.POST_BIRTH_DETAILS, birthDetail)

export const getCaptcha = () => get(url.GET_CAPTCHA)

//export const getBirthChartList = () => get(url.GET_BIRTH_CHART_LIST)

export const getBirthChartList = params => get(url.GET_BIRTH_CHART_LIST, params)

export const getBirthChart = chartId => get(`${url.GET_BIRTH_CHART}/${chartId}`)

export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } })

export const getPlaces = (country, place, placesToken) => get(url.GET_PLACES, { params: { country, place, token: placesToken } })

export const getPlacesAPIToken = () => get(url.GET_PLACES_API_TOKEN)

export const createPayPalOrder = () => post(`${url.CREATE_PAYPAL_ORDER}`)
export const approvePayPalOrder = (orderId, reportID) => post(`${url.CREATE_PAYPAL_ORDER}/${orderId}/${reportID}/capture`)
export const reportOrderConfirmatation = (reportID) => post(`${url.CREATE_PAYPAL_ORDER}/${reportID}/confirmation`)

//export const getPlaces = placeInput => get(`${url.GET_PLACES}/${placeInput}`)


//export const activateUser = token => get(`${url.ACTIVATE_USER}/${token}`)

export const activateUser = token => get(url.ACTIVATE_USER, { params: { token } })

// Product Admin

export const productAdminLogin = data => post(url.PRODUCT_ADMIN_LOGIN, data)

export const getProductAdminProfile = () => get(url.PRODUCT_ADMIN_PROFILE)

export const getUserBirthChartList = params => get(url.GET_USER_BIRTH_CHART_LIST, params)

export const getBirthChartPDF = birthChartId => getPDF(url.GET_BIRTH_CHART_PDF, { params: { birthChartId } })

export const getBirthChartReport = birthChartId => get(`${url.GET_BIRTH_CHART_REPORT}/${birthChartId}`)

export const getBirthChartForProductAdmin = params => get(url.GET_BIRTH_CHART_FOR_PRODUCT_ADMIN, params)

// Product Admin - Reports

export const reportValidate = (report) => post(url.REPORT_UPLOAD, report)

export const reportUpload = data => put(url.REPORT_UPLOAD, data)

// Product Admin - User Management
export const getAstroUser = (params) => get(url.ASTRO_KEY, params)
export const getAstroUserDetails = id => get(`${url.ASTRO_KEY}/${id}`)

export const getAstroUserProfile = () => get(url.ASTRO_USER_PROFILE)

export const editAstroUserProfile = (data) => put(url.ASTRO_USER_PROFILE, data)

// Group
export const getReportForGroupUser = reportId => get(`${url.GRP_REPORT}/${reportId}`)

export const getReportForGroupAdmin = reportId => get(`${url.GET_GRP_REPORT_FOR_GROUP_ADMIN}/${reportId}`)

export const getReportForBranchAdmin = reportId => get(`${url.GET_GRP_REPORT_FOR_BRANCH_ADMIN}/${reportId}`)

export const getAllReportForGroupUser = params => get(url.GRP_REPORT, params)

export const getAllReportForGroupAdmin = params => get(url.GET_GRP_REPORT_FOR_GROUP_ADMIN, params)

export const getGRPBranchesForAutoSuggest = (params) => get(url.GET_GRP_BRANCHES_AUTOSUGGEST, params)

//export const getGRPGroupUsersForAutoSuggest = id => get(`${url.GET_GRP_GROUP_USER_AUTOSUGGEST}/${id}`)

export const getGRPGroupUsersForAutoSuggest = params => get(url.GET_GRP_GROUP_USER_AUTOSUGGEST, params)

export const getGRPGroupMastersForAutoSuggest = () => get(url.GET_GRP_GROUP_MASTERS_AUTOSUGGEST)

export const postGRPBirthDetails = birthDetail => post(url.POST_GRP_BIRTH_DETAILS, birthDetail)

export const getProfileGRPUser = () => get(url.GET_GRP_USER_PROFILE)

export const getOrganizationProfile = () => get(url.GET_ORGANIZATION_PROFILE)

export const getUserDashboard = () => get(url.GET_USER_DASHBOARD)

export const getReportDashboard = () => get(url.GET_REPORT_DASHBOARD)
// export const getGRPBranchesAdmin = () => get(url.GET_GRP_BRANCHES_ADMIN)

export const getGroupMasters = () => get(url.GET_GRP_GROUP_MASTERS_AUTOSUGGEST)

// export const getGRPGroupUsers = (branchId) => get(`${url.GET_GRP_GROUP_USER_ADMIN}/${branchId}`)

export const getInvoice = () => get(url.GET_INVOICE)

export const makePayment = () => post(url.MAKE_PAYMENT)

export const groupautoGenerationReport = (groupReport) => post(url.GROUP_REPORT_CREATE, groupReport)

export const groupFetchReportAPI = (token) => get(url.GROUP_FETCH, token)

export {
  getLoggedInUser,
  isUserAuthenticated,
  postJwtRegister,
  postJwtProfile,
  postJwtLogin,
}
